import { useRecoilValue } from "recoil";
import { AppNav } from ".";
import { ReactComponent as LogoSimple } from "../../assets/img/logo/kpp-logo-full.svg";
import { LinkUnderline } from "../helpers";
import AppNavMobile from "./AppNavMobile";
import { useHeaderScroll } from "../../helpers/header";

//Atoms
import { showMobileMenuAtom } from "../../atoms/layout";

const AppHeader = () => {
	const { visible, pastThreshold, scrollThreshold } = useHeaderScroll();
	const showMobileMenu = useRecoilValue(showMobileMenuAtom);

	return (
		<>
			<header
				className="appHeader"
				data-mobilenav-visible={showMobileMenu}
				data-visible={visible}
				data-past-threshold={pastThreshold}
				data-scroll-threshold={scrollThreshold}>
				<LinkUnderline side="right" destination="/" text={<LogoSimple />} linkClasses="appHeader-logo" />
				<AppNav />
			</header>
			<AppNavMobile />
		</>
	);
};

export default AppHeader;
